// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowRightOutlinedSvg from "@fishx/icons-svg/es/asn/ArrowRightOutlined";
import FishxIcon from '../components/FishxIcon';

var ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowRightOutlinedSvg
  }));
};

ArrowRightOutlined.displayName = 'ArrowRightOutlined';
export default React.forwardRef(ArrowRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ArrowRightOutlined.js
// module id = 2017
// module chunks = 0